

/** @type {import('./floor')} */
module.exports = Math.floor;




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/floor.js
// module id = ../node_modules/math-intrinsics/floor.js
// module chunks = 1